// trigger resize ta.dispatchEvent(new Event('input', { bubbles: true }))

class AutoresizeTextarea {
    constructor() {
        const textAreas = document.querySelectorAll('textarea[data-autoresize]')

        textAreas.forEach(ta => {
            ta.setAttribute('style', 'height:' + (ta.scrollHeight) + 'px; overflow-y: hidden;')
            ta.addEventListener('input', this.onInput.bind(this), false)
        })
    }

    onInput(e) {
        e.target.style.height = 'auto'
        e.target.style.height = (e.target.scrollHeight) + 'px'
    }
}

export default new AutoresizeTextarea()
